<template>
    <v-row>
        <v-col class="flex-container">

            <WelcomeAndSignup class="flex-item" />

            <StartEarningComponent class="flex-item" />

            <div class="add-space" v-if="isDesktopDevice"></div>

            <GetStarted class="flex-item" />

            <div class="add-space"></div>

            <FreeRewards class="flex-item" />

            <div class="add-space"></div>

            <complete-quests class="flex-item"/>

            <PeopleFeedback class="flex-item" />

        </v-col>
    </v-row>
</template>


<script>

import { useRouter } from 'vue-router';
import { isDesktop } from '@/utils/utils';
import { useAuthStore } from '@/store/AuthStore';
import GetStarted from '@/components/Home/Get-Started.vue';
import FreeRewards from '@/components/Home/Free-Rewards.vue';
import CompleteQuests from '@/components/Home/Complete-Quests.vue';
import PeopleFeedback from '@/components/Home/People-Feedback.vue';
import WelcomeAndSignup from '@/components/Home/Welcome-Banner.vue';
import StartEarningComponent from '@/components/Home/Start-Earning-Component.vue'
import { getReferralCodeFromSessionStorage, removeReferralCodeFromSessionStorage } from '@/utils/utils';


export default {
    name: "Home-Component",
    components: {
        GetStarted,
        FreeRewards,
        CompleteQuests,
        PeopleFeedback,
        WelcomeAndSignup,
        StartEarningComponent,
    },
    props: {
        referralCode: {
            type: String,
            default: ''
        }
    },
    setup() {
        const router = useRouter();
        const authStore = useAuthStore();
        const isDesktopDevice = isDesktop();

        const referralCode = getReferralCodeFromSessionStorage();
        if (referralCode && authStore.isUserLoggedIn()) {
            authStore.setReferralCode(referralCode);
            router.push({
                name: 'earn',
                params: { referralCode }
            });
            removeReferralCodeFromSessionStorage();
        }

        return {
            isDesktopDevice,
        };
    }
};

</script>


<style scoped lang="scss">
.flex-container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.flex-item {
    flex: 1 1 auto;
}

.add-space {
    margin-top: 150px !important;
}
</style>
